export enum EntityFieldDataType {
    _string = 1,
    _number = 2,
    _price = 3,
    _timestamp = 4,
    _date_range = 5,
    _reference = 6,
    _image_file = 7,
    _boolean = 8,
    _string_long = 9,
    _password = 10,
    _arr_string = 11,
    _date = 12,
    _viber_text = 100,
    _sms_text = 101,
    _user_image = 102,
    _sms_rule = 103,
    _send_type = 104,
    _phone_numbers = 105,
    _dynamics = 106,
	_derived = 107,
	_chips = 108,
	_predefined_chips = 109
}
